let AnimationState = /*#__PURE__*/function (AnimationState) {
  AnimationState["Idle"] = "idle";
  AnimationState["BeforeExpanding"] = "beforeExpanding";
  AnimationState["BeforeShrinking"] = "beforeShrinking";
  AnimationState["Expanding"] = "expanding";
  AnimationState["Shrinking"] = "shrinking";
  return AnimationState;
}({});
let DimensionProperty = /*#__PURE__*/function (DimensionProperty) {
  DimensionProperty["Top"] = "top";
  DimensionProperty["Bottom"] = "bottom";
  DimensionProperty["Left"] = "left";
  DimensionProperty["Width"] = "width";
  return DimensionProperty;
}({});
let SizeValue = /*#__PURE__*/function (SizeValue) {
  SizeValue["Default"] = "default";
  SizeValue["Expanded"] = "expanded";
  SizeValue["Fullscreen"] = "fullscreen";
  return SizeValue;
}({});

export { AnimationState, DimensionProperty, SizeValue };
